// Vendor
import { createAction, props } from '@ngrx/store';
export const setPortfolioImportType = createAction('[Fidelity Import Holdings] Set Portfolio Import Type', props());
export const setAccountResultsLoaded = createAction('[Fidelity Import Holdings] Set Account Results Loaded', props());
export const resetAccountResultsLoaded = createAction('[Fidelity Import Holdings] Reset Account Results Loaded');
export const selectAccount = createAction('[Fidelity Import Holdings] Select Account', props());
export const addAllAccounts = createAction('[Fidelity Import Holdings] Add All Accounts', props());
export const removeAccounts = createAction('[Fidelity Import Holdings] Remove Accounts', props());
export const resetSelectedAccounts = createAction('[Fidelity Import Holdings] Reset Selected Accounts');
